// Frontend mirror of /app/backend/services/schedule.py — single source of truth
// for which days/windows are offered in each city. Kept in sync manually.
//
// Maricopa:   Mon, Thu          -> Pickup 7am-10am AND 3pm-6pm (return after 3pm, 48 hrs later)
// Other:      Tue, Wed, Thu     -> 7-10am, 12-3pm, 3-7pm
//             + Sat 10am-2pm    -> NOT Maricopa

export const MAX_PER_SLOT = 10;

export const WINDOWS = {
  MARICOPA_AM: "7:00 AM – 10:00 AM (Pickup)",
  MARICOPA_PM: "3:00 PM – 6:00 PM (Pickup)",
  EARLY: "7:00 AM – 10:00 AM",
  MID: "12:00 PM – 3:00 PM",
  LATE: "3:00 PM – 7:00 PM",
  SAT: "10:00 AM – 2:00 PM",
};

const MARICOPA_DOW = new Set([1, 4]);          // JS Date.getDay: Mon=1, Thu=4
const OTHER_WEEKDAY_DOW = new Set([2, 3, 4]);  // Tue, Wed, Thu

export function isMaricopa(city) {
  return (city || "").trim().toLowerCase() === "maricopa";
}

/** Returns the array of window labels available for given city + JS Date.
 *  Empty array means the city is closed that day. */
export function windowsFor(city, jsDate) {
  if (!jsDate) return [];
  const dow = jsDate.getDay(); // 0=Sun ... 6=Sat
  if (dow === 0) return [];
  if (isMaricopa(city)) {
    return MARICOPA_DOW.has(dow) ? [WINDOWS.MARICOPA_AM, WINDOWS.MARICOPA_PM] : [];
  }
  if (dow === 6) return [WINDOWS.SAT];
  return OTHER_WEEKDAY_DOW.has(dow)
    ? [WINDOWS.EARLY, WINDOWS.MID, WINDOWS.LATE]
    : [];
}

/** True if the given JS Date is bookable for the given city. */
export function isDayOpen(city, jsDate) {
  return windowsFor(city, jsDate).length > 0;
}
